import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserScreenerClient = React.lazy(() =>
    import('../UserScreenerClient')
);
const userScreenerClientRoutesRegistry = [
    {
        path: PAGE_URL.USER_SCREENER_CLIENT_PAGE,
        element: <UserScreenerClient />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userScreenerClientRoutesRegistry;
